export default __webpack_public_path__ + "static/media/hair-hot-autumn.5e4a5948.png";